module.exports = __webpack_public_path__ + "static/media/Icon_EmailBoards.87114f5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_EmailBoards.svg
// module id = 2307
// module chunks = 0